function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.49467 18.2905C4.64317 19.5677 7.20653 20.4694 9.63389 20.4694C12.2302 20.4694 13.5847 19.3964 13.5847 17.841C13.5847 15.9636 11.3593 15.388 8.73548 14.7028C4.99897 13.7435 0.493165 12.565 0.493165 7.19313C0.491792 3.20669 3.77498 0 9.39349 0C12.5805 0 15.4241 0.761931 18.1303 2.04187L16.1879 6.15301C14.0367 5.08 11.7851 4.56337 9.63527 4.56337C7.31368 4.56337 5.92623 5.66926 5.92623 7.11913C5.92623 8.94173 8.11731 9.49537 10.7068 10.1477C14.4502 11.0932 19.0288 12.2498 19.0288 17.767C19.0288 21.848 15.9077 25.0273 9.67373 25.0273C6.03338 25.0273 2.32433 23.8213 0 22.3646L2.49742 18.2877L2.49467 18.2905Z",
  fill: "white"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.1724 0.416409H40.848V4.97978H28.409V10.3051H39.4977V14.3477H28.409V20.0525H40.9868V24.6159H23.1724V0.415039V0.416409Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M50.6774 0.416382H45.4092V24.6173H50.6774V0.416382Z",
  fill: "white"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M98.8001 0.416382H81.4019V24.6173H86.6701V14.9369H97.1379V10.6477H86.6701V4.98112H98.8001V0.417752V0.416382Z",
  fill: "white"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M103.154 0.416559H113.828C120.761 0.416559 123.15 4.21937 123.15 8.09069C123.15 10.9246 121.721 13.4831 118.713 14.7644L123.356 24.6175H117.71L113.96 15.5949H108.41V24.612H103.148V0.413818L103.154 0.416559ZM113.759 11.7564C116.534 11.7564 117.884 10.1942 117.884 8.15236C117.884 6.04197 116.497 4.58937 113.793 4.58937H108.422V11.7564H113.759Z",
  fill: "white"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M140.296 0.416614H134.336L125.569 24.6148H131.218L132.707 20.0884H141.925L143.45 24.6106H149.064L140.296 0.411133V0.416614ZM140.573 16.043H134.023L137.246 6.22154L137.315 6.22428L140.573 16.043Z",
  fill: "white"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.4716 45.1266C25.2573 45.6063 26.1681 45.9352 27.1434 45.9352C28.3111 45.9352 28.8881 45.4281 28.8881 44.7224C28.8881 43.8549 27.9539 43.6124 26.8824 43.3383C25.495 42.982 23.9152 42.575 23.9152 40.6701C23.9152 39.2587 25.0966 38.1322 27.0748 38.1322C28.2424 38.1322 29.2727 38.42 30.1519 38.853L29.5887 40.0658C28.8263 39.6803 27.9844 39.4771 27.1297 39.4724C26.1132 39.4724 25.5087 39.9863 25.5087 40.6441C25.5087 41.4937 26.4428 41.7267 27.5006 42.0008C28.9018 42.3434 30.5091 42.7545 30.5091 44.7004C30.5091 46.153 29.4101 47.263 27.1847 47.263C25.8796 47.263 24.6295 46.8382 23.7778 46.3175L24.5196 45.1116L24.4716 45.1266Z",
  fill: "white"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.8679 43.3313C37.8679 41.5773 36.9476 40.2754 35.0079 40.2754C33.1492 40.2754 31.7329 41.6156 31.7329 43.7219C31.7329 45.9556 33.0338 47.2849 35.0436 47.2849C35.9956 47.2849 36.8953 46.9807 37.6646 46.449L37.019 45.476C36.464 45.8323 35.8184 46.0831 35.137 46.0831C33.9446 46.0831 33.288 45.3636 33.2138 44.0001H37.8185L37.8679 43.3313ZM36.453 43.0532H33.2742C33.4666 41.9939 34.1479 41.3758 35.0463 41.3758C36.0849 41.3758 36.4516 42.1199 36.4516 43.0532H36.453Z",
  fill: "white"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M42.3552 40.2894C43.2275 40.2894 43.9981 40.569 44.6699 41.0842L43.8965 42.0709C43.5063 41.7694 43.0255 41.5145 42.3936 41.5145C41.329 41.5145 40.5446 42.3477 40.5446 43.7236C40.5446 45.1872 41.3056 46.0587 42.3936 46.0587C43.0667 46.0587 43.5201 45.823 43.9624 45.4393L44.7963 46.3246C44.0751 46.9687 43.3401 47.2729 42.3552 47.2729C40.4319 47.2729 39.0527 45.9436 39.0527 43.7236C39.0527 41.6036 40.4539 40.2894 42.3634 40.2894H42.3552Z",
  fill: "white"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M47.4732 40.4398H46.1338V47.119H47.6009V42.9531C48.068 42.0829 48.5763 41.6156 49.3098 41.6156C49.6491 41.6156 49.9033 41.6786 50.156 41.78L50.4225 40.4288C50.1416 40.3142 49.84 40.2582 49.5365 40.2644C48.726 40.2644 48.0803 40.67 47.5858 41.5388L47.4718 40.4398H47.4732Z",
  fill: "white"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M54.2267 40.2754C56.1664 40.2754 57.0868 41.5773 57.0868 43.3313L57.0319 44.0001H52.4299C52.4986 45.3636 53.158 46.0831 54.3531 46.0831C55.0262 46.0831 55.6719 45.8309 56.2351 45.476L56.8808 46.449C56.1115 46.9807 55.2048 47.2849 54.2569 47.2849C52.2376 47.2849 50.9463 45.9556 50.9463 43.7219C50.9463 41.6156 52.3612 40.2754 54.2157 40.2754H54.2267ZM52.4931 43.0532H55.6705C55.6705 42.1213 55.3037 41.3758 54.2638 41.3758C53.3668 41.3758 52.684 41.9925 52.4917 43.0532H52.4931Z",
  fill: "white"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M58.0189 41.5421H59.1481V45.2531C59.1481 46.6166 59.78 47.2716 61.0987 47.2716C61.7444 47.2716 62.4038 47.0208 62.8434 46.6824L62.2801 45.7437C61.9905 45.9592 61.6387 46.0755 61.2773 46.0753C60.8103 46.0753 60.5905 45.7848 60.5905 45.2256V41.5421H62.445V40.4416H60.5905V38.6602H59.1343V40.4554H57.9941V41.5654L58.0189 41.5421Z",
  fill: "white"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M67.6455 43.1672V42.4231C67.6455 41.8681 67.3158 41.4912 66.5562 41.4912C65.9105 41.4912 65.1825 41.7818 64.4544 42.1463L63.9186 40.9952C64.7291 40.606 65.7457 40.2894 66.6249 40.2894C68.4107 40.2894 69.1388 41.187 69.1388 42.4601V45.4791C69.1388 45.9094 69.386 46.0848 69.7707 46.0848V47.14C68.658 47.14 68.1909 46.9207 67.8612 46.3588C67.3254 46.907 66.6798 47.2633 65.7869 47.2633C64.6055 47.2633 63.7812 46.537 63.7812 45.4955C63.7812 43.8785 65.4984 43.2755 67.6964 43.1522L67.6455 43.1672ZM66.1138 46.1601C66.7732 46.1601 67.2952 45.8833 67.6386 45.5051V44.0758C66.471 44.1306 65.1934 44.3553 65.1934 45.3776C65.1934 45.8573 65.5643 46.1588 66.1001 46.1588L66.1138 46.1601Z",
  fill: "white"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M72.4206 40.4401H71.084V47.1193H72.5511V42.9533C73.0182 42.0831 73.5265 41.6158 74.26 41.6158C74.5897 41.6158 74.8507 41.6789 75.098 41.7803L75.359 40.4291C75.1117 40.3263 74.8232 40.2646 74.4661 40.2646C73.6556 40.2646 73.0099 40.6703 72.5154 41.5391L72.3918 40.4401H72.4206Z",
  fill: "white"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M76.6196 40.5085H78.0895V47.1206H76.6196V40.5085Z",
  fill: "white"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M76.6196 37.6771H78.0895V39.0914H76.6196V37.6771Z",
  fill: "white"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M83.5777 42.4232V43.1686C81.377 43.292 79.6694 43.8949 79.6694 45.512C79.6694 46.5672 80.4937 47.2798 81.6819 47.2798C82.5666 47.2798 83.2246 46.9235 83.7562 46.3753C84.0859 46.9509 84.553 47.1702 85.6657 47.1702V46.115C85.2879 46.115 85.0475 45.9368 85.0475 45.512V42.4821C85.0475 41.2076 84.3277 40.3114 82.5419 40.3114C81.6558 40.3114 80.6434 40.6266 79.8357 41.0199L80.3783 42.171C81.1118 41.8065 81.8317 41.5132 82.4897 41.5132C83.2507 41.5132 83.5777 41.8928 83.5777 42.4451V42.4232ZM83.5777 45.5065C83.3843 45.7176 83.148 45.8851 82.8846 45.9978C82.6212 46.1105 82.3367 46.1659 82.0501 46.1602C81.5047 46.1602 81.1366 45.8587 81.1366 45.3791C81.1366 44.3554 82.4141 44.1293 83.5777 44.0772V45.5051V45.5065Z",
  fill: "white"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M89.8726 43.674C89.8726 41.4814 90.9496 40.2892 92.5444 40.2892C93.3412 40.2892 94.0377 40.6565 94.5803 41.2279V37.5923H96.0474V47.1205H94.7451L94.6435 46.312C94.1132 46.8684 93.4442 47.2713 92.5444 47.2713C90.9344 47.2713 89.8726 46.0242 89.8726 43.674ZM94.5803 45.3048V42.2995C94.0857 41.7418 93.5459 41.4499 92.9098 41.4499C91.8851 41.4499 91.3534 42.2228 91.3534 43.6877C91.3534 45.2157 91.8851 46.1133 92.9098 46.1133C93.5665 46.1133 94.0734 45.8721 94.5803 45.3048Z",
  fill: "white"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M103.71 43.3313C103.71 41.5773 102.789 40.2754 100.848 40.2754C98.9896 40.2754 97.5747 41.6156 97.5747 43.7219C97.5747 45.9556 98.8756 47.2849 100.885 47.2849C101.824 47.2803 102.739 46.9886 103.506 46.449L102.861 45.476C102.306 45.8323 101.66 46.0831 100.976 46.0831C99.7864 46.0831 99.1298 45.3636 99.0528 44.0001H103.66L103.71 43.3313ZM102.295 43.0532H99.1146C99.307 41.9939 99.9897 41.3758 100.887 41.3758C101.925 41.3758 102.293 42.1199 102.293 43.0532H102.295Z",
  fill: "white"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M108.548 38.282H114.823V39.6195H110.057V42.0176H114.332V43.2647H110.055V45.7999H114.888V47.1429H108.548V38.3039V38.282Z",
  fill: "white"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M118.758 46.1108C118.01 46.1108 117.288 45.8436 116.67 45.4777L116.047 46.5274C116.872 47.0043 117.751 47.2729 118.767 47.2729C120.292 47.2729 121.391 46.5644 121.391 45.2269C121.391 43.7428 120.114 43.4221 119.056 43.1535C118.287 42.9617 117.641 42.7972 117.641 42.2491C117.641 41.705 118.108 41.4501 118.74 41.4501C119.262 41.4501 119.976 41.642 120.581 41.9435L121.13 40.8581C120.265 40.4676 119.454 40.2894 118.712 40.2894C117.325 40.2894 116.171 41.0102 116.171 42.308C116.171 43.7428 117.421 44.073 118.479 44.3526C119.248 44.5582 119.935 44.7363 119.935 45.3023C119.935 45.871 119.427 46.1108 118.712 46.1108H118.758Z",
  fill: "white"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M123.385 41.5421H122.258V40.4416H123.385V38.6602H124.855V40.4554H126.712V41.5654H124.855V45.2517C124.855 45.8135 125.068 46.1013 125.535 46.1013C125.901 46.1013 126.231 45.9917 126.537 45.7724L127.092 46.718C126.639 47.0606 125.98 47.3073 125.334 47.3073C124.015 47.3073 123.37 46.6632 123.37 45.2928V41.5791L123.385 41.5421Z",
  fill: "white"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M131.881 42.4232V43.1686C129.68 43.292 127.97 43.8949 127.97 45.512C127.97 46.5672 128.794 47.2798 129.984 47.2798C130.87 47.2798 131.528 46.9235 132.061 46.3753C132.388 46.9509 132.858 47.1702 133.971 47.1702V46.115C133.59 46.115 133.35 45.9368 133.35 45.512V42.4821C133.35 41.2076 132.629 40.3114 130.845 40.3114C129.966 40.3114 128.95 40.6266 128.139 41.0199L128.689 42.171C129.43 41.8065 130.145 41.5132 130.804 41.5132C131.573 41.5132 131.889 41.8928 131.889 42.4451L131.881 42.4232ZM131.881 45.5065C131.688 45.7179 131.451 45.8856 131.187 45.9984C130.923 46.1111 130.638 46.1663 130.351 46.1602C129.815 46.1602 129.444 45.8587 129.444 45.3791C129.444 44.3554 130.722 44.1293 131.889 44.0772V45.5051L131.881 45.5065Z",
  fill: "white"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M134.994 43.674C134.994 41.4814 136.068 40.2892 137.663 40.2892C138.462 40.2892 139.157 40.6565 139.699 41.2279V37.5923H141.168V47.1205H139.863L139.763 46.312C139.231 46.8684 138.564 47.2713 137.661 47.2713C136.054 47.2713 134.992 46.0242 134.992 43.674H134.994ZM139.699 45.3048V42.2995C139.207 41.7418 138.664 41.4499 138.028 41.4499C136.998 41.4499 136.462 42.2228 136.462 43.6877C136.462 45.2157 136.984 46.1133 138.014 46.1133C138.674 46.1133 139.168 45.8721 139.677 45.3048H139.699Z",
  fill: "white"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M149.296 43.7017C149.296 41.6283 147.895 40.2894 146.008 40.2894C144.112 40.2894 142.694 41.6283 142.694 43.7017C142.694 45.908 144.021 47.2701 146.008 47.2701C147.969 47.2701 149.296 45.9066 149.296 43.7003V43.7017ZM147.792 43.7113C147.792 45.1639 147.122 46.1231 146.006 46.1231C144.857 46.1231 144.185 45.1639 144.185 43.7113C144.185 42.3573 144.94 41.4501 146.012 41.4501C147.083 41.4501 147.798 42.3573 147.798 43.7113H147.792Z",
  fill: "white"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M46.1914 58.0631C46.1914 55.8623 47.2684 54.6783 48.8633 54.6783C49.6628 54.6783 50.3579 55.0414 50.8991 55.6101V51.9745H52.369V61.5041H51.064L50.9623 60.7093C50.4403 61.2711 49.7672 61.6686 48.8702 61.6686C47.2629 61.6686 46.1983 60.4215 46.1983 58.0782L46.1914 58.0631ZM50.8991 59.6884V56.6845C50.4074 56.1281 49.8647 55.8376 49.2287 55.8376C48.2039 55.8376 47.6737 56.605 47.6737 58.0713C47.6737 59.5979 48.2039 60.4969 49.2287 60.4969C49.8853 60.4969 50.3922 60.2543 50.8991 59.6884Z",
  fill: "white"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M60.0324 57.7162C60.0324 55.9594 59.112 54.6603 57.1723 54.6603C55.3178 54.6603 53.9028 56.0005 53.9028 58.1082C53.9028 60.3419 55.2079 61.667 57.2135 61.667C58.1614 61.667 59.068 61.3655 59.8373 60.8352L59.1917 59.8622C58.6422 60.2185 57.9965 60.4679 57.3097 60.4679C56.1283 60.4679 55.4689 59.7471 55.3864 58.385H60.0021L60.0571 57.7162H60.0324ZM58.6174 57.4394H55.4373C55.6296 56.3787 56.3123 55.7579 57.2094 55.7579C58.2479 55.7579 58.6161 56.5048 58.6161 57.4394H58.6174Z",
  fill: "white"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M64.8716 52.6669H66.3909V61.5058H64.8798V52.6669H64.8716Z",
  fill: "white"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M69.699 54.8288H68.3198V61.5052H69.7897V56.7199C70.2568 56.1416 70.8269 55.8113 71.5206 55.8113C72.2693 55.8113 72.5729 56.3046 72.5729 57.0351V61.5052H74.04V57.0625C74.04 55.6099 73.3724 54.6643 71.8778 54.6643C71.0178 54.6643 70.2842 55.0919 69.776 55.6236L69.7004 54.8288H69.699Z",
  fill: "white"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M76.3431 56.0016H75.2139V54.9012H76.3431V54.497C76.3431 52.5921 77.4558 51.885 79.0122 51.885C79.4793 51.885 79.9875 52.0001 80.331 52.1248L79.9601 53.1855C79.6853 53.117 79.4106 53.0485 79.0259 53.0485C78.1742 53.0485 77.7896 53.5281 77.7896 54.4874V54.9122H79.5754V56.0085H77.7896V61.5174H76.3197V56.0085L76.3431 56.0016Z",
  fill: "white"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  d: "M82.3828 54.826H81.0462L81.0435 61.5025H82.5133V57.3365C82.9804 56.465 83.4846 55.999 84.2195 55.999C84.5602 55.999 84.8143 56.0593 85.0657 56.1607L85.3322 54.8123C85.0507 54.6993 84.7495 54.6434 84.4462 54.6478C83.6384 54.6478 82.99 55.0507 82.4982 55.9223L82.3828 54.826Z",
  fill: "white"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M89.9629 57.5562V56.8093C89.9629 56.2543 89.6332 55.8775 88.8736 55.8775C88.2169 55.8775 87.4998 56.1652 86.7608 56.5311L86.2113 55.3841C87.0218 54.9922 88.0246 54.677 88.9175 54.677C90.7034 54.677 91.4177 55.5678 91.4177 56.8422V59.857C91.4177 60.2819 91.6512 60.46 92.0359 60.46V61.5152C90.9232 61.5152 90.4424 61.2959 90.1264 60.7341C89.5906 61.2822 88.9313 61.6385 88.0521 61.6385C86.8569 61.6385 86.0327 60.9122 86.0327 59.8707C86.0327 58.2537 87.7361 57.637 89.9341 57.5274L89.9629 57.5562ZM88.4312 60.5436C89.1043 60.5436 89.6236 60.2695 89.9629 59.8899V58.4647C88.7994 58.5168 87.5177 58.7388 87.5177 59.7625C87.5177 60.2421 87.8886 60.5463 88.4312 60.5436Z",
  fill: "white"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M99.1828 57.7162C99.1828 55.9594 98.2624 54.6603 96.3227 54.6603C94.4682 54.6603 93.0532 56.0005 93.0532 58.1082C93.0532 60.3419 94.3583 61.667 96.3639 61.667C97.3118 61.667 98.2184 61.3655 98.9877 60.8352L98.3421 59.8622C97.7926 60.2185 97.1469 60.4679 96.4601 60.4679C95.2787 60.4679 94.6193 59.7471 94.5368 58.385H99.1525L99.2075 57.7162H99.1828ZM97.7678 57.4394H94.5904C94.7786 56.3787 95.4614 55.7579 96.3584 55.7579C97.3983 55.7579 97.7651 56.5048 97.7651 57.4394H97.7678Z",
  fill: "white"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M100.939 59.8639C101.559 60.2312 102.278 60.497 103.027 60.497C103.737 60.497 104.241 60.2545 104.241 59.6885C104.241 59.1212 103.565 58.943 102.785 58.7388C101.724 58.4593 100.471 58.1304 100.471 56.6969C100.471 55.3951 101.621 54.677 103.016 54.677C103.746 54.677 104.571 54.8414 105.431 55.2389L104.874 56.3215C104.267 56.02 103.542 55.8281 103.028 55.8281C102.396 55.8281 101.929 56.0748 101.929 56.6229C101.929 57.1711 102.588 57.3355 103.344 57.5274C104.415 57.7878 105.679 58.1167 105.679 59.5967C105.679 60.9259 104.58 61.6385 103.055 61.6385C102.053 61.6385 101.173 61.3645 100.335 60.8848L100.954 59.8296L100.939 59.8639Z",
  fill: "white"
});

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  d: "M106.521 55.9252H107.647L107.65 59.6362C107.65 60.9997 108.293 61.6548 109.609 61.6548C110.255 61.6548 110.914 61.4081 111.354 61.0655L110.8 60.1336C110.495 60.3529 110.165 60.4625 109.797 60.4625C109.33 60.4625 109.117 60.1747 109.117 59.6266V55.9403H110.976V54.844H109.117V53.0337H107.647V54.8289H106.521V55.9252Z",
  fill: "white"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  d: "M112.519 54.8263H113.858L113.974 55.9226C114.455 55.0511 115.114 54.6482 115.911 54.6482C116.268 54.6482 116.556 54.714 116.79 54.8126L116.515 56.1611C116.245 56.0511 115.955 55.9961 115.664 55.9994C114.922 55.9994 114.413 56.4653 113.946 57.3369V61.5028H112.505V54.8263H112.519Z",
  fill: "white"
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  d: "M119.462 54.8267H117.992L117.995 59.2571C117.995 60.7097 118.638 61.6553 120.157 61.6553C121.023 61.6553 121.764 61.2305 122.286 60.696L122.383 61.5045H123.743V54.8308H122.258V59.6134C121.777 60.1752 121.205 60.5178 120.496 60.5178C119.713 60.5178 119.462 60.0245 119.462 59.2982V54.8308V54.8267Z",
  fill: "white"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  d: "M126.063 55.9252H124.934V54.8289H126.061V53.0337H127.53V54.8289H129.389V55.9252H127.535V59.6115C127.535 60.1665 127.754 60.4557 128.221 60.4557C128.592 60.4557 128.922 60.3433 129.224 60.1295L129.787 61.0614C129.348 61.404 128.688 61.6548 128.043 61.6548C126.724 61.6548 126.078 61.0107 126.078 59.6403V55.9266L126.063 55.9252Z",
  fill: "white"
});

var _ref40 =
/*#__PURE__*/
React.createElement("path", {
  d: "M132.373 54.8267H130.903V59.2571C130.903 60.7097 131.549 61.6553 133.071 61.6553C133.937 61.6553 134.692 61.2305 135.2 60.696L135.296 61.5045H136.656V54.8308H135.171V59.6134C134.691 60.1752 134.122 60.5178 133.413 60.5178C132.625 60.5178 132.373 60.0245 132.373 59.2982V54.8308V54.8267Z",
  fill: "white"
});

var _ref41 =
/*#__PURE__*/
React.createElement("path", {
  d: "M138.468 54.8263H139.805L139.92 55.9226C140.415 55.0511 141.06 54.6482 141.871 54.6482C142.225 54.6482 142.517 54.714 142.756 54.8126L142.495 56.1611C142.229 56.051 141.944 55.996 141.657 55.9994C140.929 55.9994 140.42 56.4653 139.953 57.3369V61.5028H138.483V54.8263H138.468Z",
  fill: "white"
});

var _ref42 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M147.382 56.8093V57.5561C145.182 57.6657 143.474 58.2728 143.474 59.8899C143.474 60.9382 144.298 61.6577 145.487 61.6577C146.373 61.6577 147.029 61.3014 147.561 60.7477C147.891 61.3096 148.358 61.5288 149.47 61.5288V60.4599C149.094 60.4599 148.852 60.2818 148.852 59.8433V56.8284C148.852 55.554 148.132 54.6495 146.347 54.6495C145.461 54.6495 144.448 54.9647 143.64 55.3484L144.183 56.4995C144.925 56.1295 145.639 55.8418 146.298 55.8418C147.068 55.8418 147.397 56.2118 147.397 56.7736L147.382 56.8093ZM147.382 59.8899C147.189 60.1015 146.953 60.2694 146.69 60.3824C146.426 60.4954 146.142 60.5508 145.855 60.5449C145.309 60.5586 144.943 60.2434 144.943 59.7638C144.943 58.7497 146.22 58.5167 147.384 58.4756V59.9008L147.382 59.8899Z",
  fill: "white"
});

var _ref43 =
/*#__PURE__*/
React.createElement("path", {
  d: "M55.6309 0.416382H60.6202L71.4342 16.3539V0.416382H76.3933V24.6173H71.4314L60.6202 8.74829V24.6173H55.6309V0.416382Z",
  fill: "white"
});

var SvgLogoSeinfra = function SvgLogoSeinfra(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 150,
    height: 62,
    viewBox: "0 0 150 62",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoSeinfra, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-seinfra.7f6ab4bf.svg";
export { ForwardRef as ReactComponent };